// src/components/pages/UnauthorizedPage/UnauthorizedPage.tsx
import React, { useEffect } from 'react';
import './UnauthorizedPage.scss';

const UnauthorizedPage: React.FC = () => {
    useEffect(() => {
        // Скрываем навигацию при монтировании компонента
        const navigation = document.querySelector('.tg-navigation');
        if (navigation) {
            (navigation as HTMLElement).style.display = 'none';
        }

        // Возвращаем навигацию при размонтировании
        return () => {
            const navigation = document.querySelector('.tg-navigation');
            if (navigation) {
                (navigation as HTMLElement).style.display = 'flex';
            }
        };
    }, []);

    return (
        <div className="tg-app unauthorized-page">
            <div className="error-container">
                <div className="error-code">404</div>
                <div className="error-line"></div>
            </div>
        </div>
    );
};

export default UnauthorizedPage;